import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import PageNotFound from './pages/PageNotFound'

import Signup from './pages/Auth/Signup'
import Login from './pages/Auth/Login'
import ForgotPassword from './pages/Auth/ForgotPassword/ForgotPassword'
import ResetPassword from './pages/Auth/ForgotPassword/ResetPassword'

import DefaultLayout from './layout/DefaultLayout'

import PublicRoute from './components/Custom/CustomRoutes/PublicRoute'
import PrivateRoute from './components/Custom/CustomRoutes/PrivateRoute'

import AllRoutes from './navigation'
import { Toaster } from 'react-hot-toast'

import View360View from './pages/360View/actions/View'
import ViewArView from './pages/ARView/actions/View'
import ViewMetaverse from './pages/Metaverse/actions/View';
import { PermissionProvider } from './context/permission'
import { ProfileProvider } from './context/profile'
import { FestivalProvider } from './context/festival'
import TaskNotificationListener from './components/NotificationListener'
import SocketProvider from './context/socket';
import DynamicView360 from './pages/Dynamic360/actions/View'

const App = () => {
  return (
    <BrowserRouter>
        <Toaster />
      <SocketProvider>
        <PermissionProvider>
          <ProfileProvider>
            <FestivalProvider>
              <TaskNotificationListener />
              <Routes>
                <Route path='/*' element={<PageNotFound />} />
                <Route path='/360view/view/:id' element={<View360View />} />
                <Route path='/arview/view/:id' element={<ViewArView />} />
                <Route path='/metaverse/view/:id' element={<ViewMetaverse />} />
                <Route path='/dynamic-360/view/:id' element={<DynamicView360 />} />
                <Route element={<PublicRoute />}>
                  <Route path='/signup' element={<Signup />} />
                  <Route path='/login' element={<Login />} />
                  <Route path='/forgot-password' element={<ForgotPassword />} />
                  <Route path='/reset-password' element={<ResetPassword />} />
                </Route>
                <Route element={<PrivateRoute />}>
                  <Route element={<DefaultLayout />}>
                    {AllRoutes.map((route, index) => {
                      return (
                        <Route key={index} path={route.path} element={route.element} />
                      )
                    })}
                  </Route>
                </Route>
              </Routes>
            </FestivalProvider>
          </ProfileProvider>
        </PermissionProvider>
      </SocketProvider>
    </BrowserRouter>
  )
}

export default App
